import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { collections } from '../data/collections';
export function CollectionsSection() {
  return <section className="bg-brand-alt px-4 py-16 md:py-24" data-id="element-34" data-mp="3h1j3idxw98ox">
      <Reveal className="mx-auto max-w-[1120px]" data-id="element-35" data-mp="3gzy9qqjelts4">
        <div className="mx-auto mb-10 max-w-3xl text-center md:mb-12" data-id="element-36" data-mp="3c2oe2t5f8lvu">
          <p className="mb-3 text-[11px] font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-37" data-mp="3c0lmw5sj8mpj">THE COMPLETE SYSTEM</p>
          <h2 className="text-3xl font-black text-brand-blue md:text-[2.5rem]" data-id="element-38" data-mp="3248k8if0eyin">
            What&apos;s Inside Physical Education Ready?
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-brand-gray" data-id="element-39" data-mp="2y36tyr32lwst">
            Ten professionally structured volumes take students from foundational movement skills to confident
            participation, tactical thinking, leadership, planning, and lifelong physical activity.
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2" data-id="element-40" data-mp="racqwea06gjv">
          {collections.map(({
          icon: CollectionIcon,
          title,
          subtitle,
          volumes,
          summary
        }) => <article key={title} className="flex flex-col rounded-3xl border border-brand-dark bg-brand-main p-7 shadow-[0_12px_32px_rgba(18,58,99,0.07)] md:p-9" data-id="element-41" data-mp="n0ct8yc42yd">
              <div className="flex items-center gap-4" data-id="element-42" data-mp="3nrokde2oj5g9">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-blue text-white" data-id="element-43" data-mp="fatqup7ruxeu">
                  <CollectionIcon className="h-6 w-6" strokeWidth={1.6} aria-hidden="true" data-id="element-44" data-mp="jcos5tppdasm" />
                </span>
                <div data-id="element-45" data-mp="5jz7ptptodxm">
                  <h3 className="text-2xl font-bold text-brand-blue" data-id="element-46" data-mp="5ks3jzn8tj0z">{title}</h3>
                  <p className="text-[11px] font-extrabold tracking-[0.12em] text-brand-teal" data-id="element-47" data-mp="aitxjfm7j2r8">
                    {subtitle.toUpperCase()}
                  </p>
                </div>
              </div>
              <ul className="mt-6 space-y-2.5" data-id="element-48" data-mp="1317m0olnlcdn">
                {volumes.map(volume => <li key={volume} className="flex items-center gap-3 rounded-xl border border-brand-dark bg-brand-alt px-4 py-3" data-id="element-49" data-mp="1cv3g00cm4d6w">
                    <CheckIcon className="h-4 w-4 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-50" data-mp="12x77lgb27wch" />
                    <span className="text-sm font-semibold text-brand-text" data-id="element-51" data-mp="xy40zrffli2e">{volume}</span>
                  </li>)}
              </ul>
              <p className="mt-6 text-sm leading-relaxed text-brand-gray" data-id="element-52" data-mp="tzdd8awuvcry">{summary}</p>
              <p className="mt-5 border-t border-brand-dark pt-4 text-[11px] font-extrabold tracking-[0.1em] text-brand-gray" data-id="element-53" data-mp="p4qz3zze3646">
                60 PAGES PER VOLUME · 90 STRUCTURED ACTIVITIES
              </p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}